import { Empty, message, Skeleton } from 'antd'
import copy from 'copy-to-clipboard'
import React, { useEffect, useState } from 'react'
import { Tree } from 'react-d3-tree'
import { useParams } from 'react-router-dom'

import { AppAdmin } from 'api/app-admin'
import Breadcrumb from 'component/breadcrumb/breadcrumb'
import { BREADCRUMBS } from 'constants/breadcrumb'
import { logError } from 'utils/logger'

import './style.scss'

const AffiliatesTree = () => {
  const location = useParams()
  const address = location.address
  const [affiliatesTree, setAffiliatesTree] = useState<any[]>([])

  useEffect(() => {
    getaffiliatesTree(address)
  }, [address])

  const [loading, setLoading] = useState(false)
  const getaffiliatesTree = async (address: any) => {
    setLoading(true)
    try {
      const res = await AppAdmin.getTreeReferral({ walletAddress: address })
      if (res?.data?.success === true) {
        setAffiliatesTree(res?.data?.data)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      logError('Error: ', error)
    }
  }

  const buildOrgChart = (data: any[]) => {
    const map = new Map()

    data.forEach((item) => {
      map.set(item?.userId, {
        name: `F${item?.level} - ${item?.userAddress.slice(0, 5)}...${item?.userAddress.slice(-5)}`,
        userAddress: item?.userAddress,
        level: item?.level,
        children: [],
      })
    })
    let root = null

    // ${
    //   item?.userAddress.slice(0, 5) + "..." + item?.userAddress.slice(-5)
    // }

    data.forEach((item) => {
      if (item?.parentId === null) {
        root = map.get(item?.userId)
      } else {
        const parent = map.get(item?.parentId)
        if (parent) {
          parent.children.push(map.get(item?.userId))
        }
      }
    })

    return root
  }

  const getNodeColor = (level: number) => {
    if (level === 0) return 'red'
    if (level === 4) return 'green'
    return 'yellow'
  }

  const renderCustomNode = ({ nodeDatum }: any) => (
    <g>
      <circle
        style={{ strokeWidth: 1 }}
        r={15}
        fill={getNodeColor(nodeDatum.level)}
        onClick={() => {
          // toggleNode()
          copy(nodeDatum.userAddress)
          message.success(`Copied user address: ${nodeDatum.userAddress} Success!`)
        }}
      />
      <text
        onClick={() => {
          // toggleNode()
          copy(nodeDatum.userAddress)
          message.success(`Copied user address: ${nodeDatum.userAddress} Success!`)
        }}
        style={{ strokeWidth: 1 }}
        fill="black"
        x={20}
        y={5}
      >
        {nodeDatum.name}
      </text>
      <title style={{ width: 200 }}>User Address: &nbsp;{nodeDatum.userAddress}</title>
    </g>
  )

  const orgChart = affiliatesTree.length ? buildOrgChart(affiliatesTree) : null

  const additionalItems = [BREADCRUMBS.AFFILIATES_TREE]

  return (
    <>
      <div className="main-section affiliates">
        <Breadcrumb additionalItems={additionalItems} />
        <div className="main-title" style={{ marginBottom: 20 }}>
          Affiliates Tree
        </div>

        <div id="treeWrapper" className="affiliates-tree-wrapper">
          {!loading && orgChart && (
            <Tree
              data={orgChart}
              rootNodeClassName="node__root"
              branchNodeClassName="node__branch"
              leafNodeClassName="node__leaf"
              orientation="vertical"
              translate={{ x: 550, y: 100 }}
              nodeSize={{ x: 175, y: 100 }}
              renderCustomNodeElement={renderCustomNode}
            />
          )}
          {loading && <Skeleton />}
          {!loading && !orgChart && <Empty />}
        </div>
      </div>
    </>
  )
}

export default AffiliatesTree
